import { renderElement } from "../../utils/use-render.js";
import { useVolumeIndicatorContext } from "./context.js";
import { VolumeIndicatorCSSVars } from "@videojs/core";
import { forwardRef } from "react";
import { isFunction } from "@videojs/utils/predicate";
//#region src/ui/volume-indicator/fill.tsx
const VolumeIndicatorFill = forwardRef(function VolumeIndicatorFill(componentProps, forwardedRef) {
	const { render, className, style, ...elementProps } = componentProps;
	const { state } = useVolumeIndicatorContext();
	const fillStyle = getVolumeIndicatorFillStyle(state, style);
	return renderElement("div", {
		render,
		className,
		style: fillStyle
	}, {
		state,
		ref: forwardedRef,
		props: [elementProps]
	});
});
function getVolumeIndicatorFillStyle(state, style) {
	const vars = state.fill ? { [VolumeIndicatorCSSVars.fill]: state.fill } : void 0;
	if (!vars) return style;
	if (isFunction(style)) return (nextState) => ({
		...style(nextState),
		...vars
	});
	return {
		...style,
		...vars
	};
}
//#endregion
export { VolumeIndicatorFill };

//# sourceMappingURL=fill.js.map